import jwt_decode from 'jwt-decode';
import { addSentryBreadcrumb, captureRequestFailure } from './monitoring/sentry';



export const isJwtExpired = (token) => {
  if (typeof (token) !== 'string' || !token) throw new Error('Invalid token provided');

  let isJwtExpired = false;
  const { exp } = jwt_decode(token);
  const currentTime = new Date().getTime() / 1000;

  if (currentTime > exp) isJwtExpired = true;

  return isJwtExpired;
}

export const getFile = async (data) => {
  const {endpoint, filename} = data;

  addSentryBreadcrumb({
    category: 'file',
    message: 'File download started',
    data: {
      endpoint,
      filename,
    },
  });

  try {
    const response = await fetch(
      endpoint, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    });

    if (!response.ok) {
      const error = new Error(response.statusText || 'File download failed');
      error.status = response.status;
      throw error;
    }

    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    link.click();

    addSentryBreadcrumb({
      category: 'file',
      message: 'File download succeeded',
      data: {
        endpoint,
        filename,
        contentType: blob.type,
        size: blob.size,
      },
    });

    return blob;
  } catch (error) {
    captureRequestFailure({
      error,
      operation: 'file_download',
      url: endpoint,
      method: 'GET',
      extra: {
        filename,
      },
    });

    throw error;
  }
}
